export interface MenuItem {
  title: string;
  icon: string | null;
  route: string;
  children?: MenuItem[];
  hide?: boolean;
}

export const menuItems: MenuItem[] = [
  {
    title: "menu.dashboard",
    icon: "mdi-monitor-dashboard",
    route: "/",
  },
  {
    title: "menu.postvak-in.title",
    icon: "mdi-inbox-full",
    route: "/",
    children: [
      {
        title: "menu.postvak-in.to-review",
        icon: null,
        route: "/requests/to-approve",
      },
      {
        title: "menu.postvak-in.approved",
        icon: null,
        route: "/requests/approved",
      },
      {
        title: "menu.postvak-in.rejected",
        icon: null,
        route: "/requests/rejected",
      },
    ],
  },
  {
    title: "menu.subscriptions.title",
    icon: "mdi-account-group",
    route: "/",
    children: [
      {
        title: "menu.subscriptions.new",
        icon: null,
        route: "/subscriptions/new",
      },
      {
        title: "menu.subscriptions.active",
        icon: null,
        route: "/subscriptions/active",
      },
      {
        title: "menu.subscriptions.ended",
        icon: null,
        route: "/subscriptions/ended",
      },
      {
        title: "menu.subscriptions.all",
        icon: null,
        route: "/subscriptions/all",
      },
      {
        title: "menu.subscriptions.expensive",
        icon: null,
        route: "/subscriptions/expensive",
        hide: true, // Hide by default. Will be shown for in Menu.vue when applicable.
      },
    ],
  },
  {
    title: "menu.files",
    icon: "mdi-folder-download-outline",
    route: "/files",
    hide: true, // Hide by default. Will be shown for in Menu.vue when applicable.
  },
  {
    title: "menu.promo-material",
    icon: "mdi-presentation",
    route: "",
    children: [
      // Disabled as requested by BFNL.
      /*
      {
        title: "menu.promotion-package",
        route: "/promotion-material/promotion-package",
        icon: null,
      },
      */
      {
        title: "menu.social-media",
        route: "/promotion-material/social-media",
        icon: null,
      },
    ],
  },
  {
    title: "menu.settings",
    icon: "mdi-cog",
    route: "/",
    children: [
      {
        title: "user.user-management",
        icon: null,
        route: "/settings/user-management",
      },
      {
        title: "user.user-password-reset",
        icon: null,
        route: "/settings/password-reset",
      },
      {
        title: "settings.employeelist",
        icon: null,
        route: "/settings/employeelist",
        hide: true, // Hide by default. Will be shown for in Menu.vue when applicable.
      },
      {
        title: "settings.authorize-settings",
        icon: null,
        route: "/settings/authorize-settings",
        hide: true, // Hide by default. Will be shown for in Menu.vue when applicable.
      },
      {
        title: "settings.microsoft-entra",
        icon: null,
        route: "/settings/microsoft-entra",
        hide: true, // Hide by default. Will be shown for in Menu.vue when applicable.
      },
    ],
  },
  {
    title: "menu.logout",
    icon: "mdi-logout",
    route: "/auth/logout",
  },
];
